// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__Nh7qT","egplayaelement0a":"gallery_egplayaelement0a__Y4Fmc","titleLink":"gallery_titleLink__GZyaS","arrow":"gallery_arrow__wkILi"};